import { compose, sort, prop, path } from 'ramda';
import trimIfString from '../../util/trimIfString';

// Using the collator ensures natural string sort
const collator = new Intl.Collator(undefined, { numeric: true, sensitivity: 'base' });

const stringSorting = (selector: ReturnType<typeof prop | typeof path>, items) => {
  const keyFn = compose(trimIfString, selector);

  return sort((itemA, itemB) => {
    const keyA = keyFn(itemA);
    const keyB = keyFn(itemB);

    return collator.compare(keyA, keyB);
  }, items);
};

export default stringSorting;
